import Index from '@/views/common/Index'
import Model from '@/views/process/model/Model'
import Deploy from '@/views/process/deploy/Deploy'
import Task from '@/views/process/task/Task'
import Instance from '@/views/process/instance/Instance'

export default [
{
  path: '/index',
  name: 'index',
  redirect: 'home',
  meta: {
    auth: true
  },
  component: Index,
  children: [
    //----------------流程模型管理----------
    {
      path: '/process/model',
      meta: { auth: true, title: "流程模型管理", isRedirect: true },
      component: Model,
      children: [
        {
          path: '/',
          name: 'process/model',
          component: resolve => require(['@/views/process/model/ModelList'], resolve)
        },
        {
          path: '/process/model/insert',
          name: 'process/model/insert',
          meta: {
            auth: true,
            title: "流程模型管理新增",
            keepAlive: false
          },
          component: resolve => require(['@/views/process/model/ModelEdit'], resolve)
        },
        {
          path: '/process/model/update',
          name: 'process/model/update',
          meta: {
            auth: true,
            title: "流程模型管理编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/process/model/ModelEdit'], resolve)
        },
      ]
    },
    //----------------流程部署管理----------
    {
      path: '/process/deploy',
      meta: { auth: true, title: "流程部署管理", isRedirect: true },
      component: Deploy,
      children: [
        {
          path: '/',
          name: 'process/deploy',
          meta: {
            keepAlive: true
          },
          component: resolve => require(['@/views/process/deploy/DeployList'], resolve)
        }
      ]
    },
    //----------------任务管理----------
    {
      path: '/process/task',
      meta: { auth: true, title: "任务管理", isRedirect: true },
      component: Task,
      children: [
        {
          path: '/',
          name: 'process/task',
          component: resolve => require(['@/views/process/task/TaskList'], resolve)
        },
        {
          path: '/process/task/insert',
          name: 'process/task/insert',
          meta: {
            auth: true,
            title: "任务管理新增",
            keepAlive: false
          },
          component: resolve => require(['@/views/process/task/TaskEdit'], resolve)
        },
        {
          path: '/process/task/update',
          name: 'process/task/update',
          meta: {
            auth: true,
            title: "任务管理编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/process/task/TaskEdit'], resolve)
        },
      ]
    },
    //----------------流程实例管理----------
    {
      path: '/process/instance',
      meta: { auth: true, title: "流程实例管理", isRedirect: true },
      component: Instance,
      children: [
        {
          path: '/',
          name: 'process/instance',
          meta: {
            keepAlive: true
          },
          component: resolve => require(['@/views/process/instance/InstanceList'], resolve)
        },
        {
          path: '/process/instance/task',
          name: 'process/instance/task',
          meta: {
            auth: true,
            title: "流程实例任务列表",
            keepAlive: false
          },
          component: resolve => require(['@/views/process/instance/InstanceTask'], resolve)
        },
      ]
    },
  ]
}]


// WEBPACK FOOTER //
// ./src/router/process.js